import { loadJSON } from './toolbox.js';
const rtl = (document.querySelector('html').getAttribute('dir') == 'rtl');

class TwitterFeed {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.feed = el.querySelector('[data-twitter-slider-list]');
    loadJSON('/tweets', (data) => {
      this.data = JSON.parse(data);
      //console.log(this.data[1]);
      this.renderTweets();
      requestAnimationFrame(() => {
        this.initSlider();
      })
    })
  }
  renderTweets(){
    let tweets = '';
    this.data.forEach(tweet => {
      tweets += `
        <div class="tweet">${tweet.text}</div>
      `
    });
    this.feed.innerHTML = tweets;
  }
  initSlider() {
    this.prevArrow = this.el.querySelector('[data-twitter-slider-prev]');
    this.nextArrow = this.el.querySelector('[data-twitter-slider-next]');
    $(this.feed).slick({
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      //fade: true,
      infinite: true,
      autoplay: true,
      arrows: true,
      dots: false,
      prevArrow: this.prevArrow,
      nextArrow: this.nextArrow,
      rtl
    });
  }
}

export default function () {
  var feed = document.querySelector('[data-twitter-feed]');

  if (feed) {
    new TwitterFeed(feed);
  }
}



// WEBPACK FOOTER //
// ./public/javascripts/modules/twitter-feed.js